import Parser from 'rss-parser'
import useSWR from 'swr'
import { API_BASE_URL } from '~/settings'

// New feed URL on the space proxy
const FEED_URL = `${API_BASE_URL}feeds/events`

export interface FeedItem extends Parser.Item {
	title: string;
	guid: string;
	pubDate: string;
	description: string;
	// For backward compatibility
	isoDate: string;
	link: string;
	content: string;
	// Optional media content
	'media:group'?: {
		'media:content': { $: { url: string } }[];
	};
	// New enclosure field for images
	enclosure?: {
		url: string;
		length?: number;
		type?: string;
	};
}

const parser = new Parser({
	customFields: {
		item: ['guid', 'pubDate', 'description', 'enclosure'],
	},
})

const feedApiFetcher = async (): Promise<FeedItem[]> => {
	try {
		const feed = await parser.parseURL(FEED_URL)
		return feed.items.map(item => {
			const feedItem = item as FeedItem
			// Map fields for backward compatibility
			feedItem.isoDate = feedItem.pubDate || ''
			feedItem.link = feedItem.link || feedItem.guid || ''
			feedItem.content = feedItem.content || feedItem.description || ''

			// Handle enclosure (image) data
			if (feedItem.enclosure && feedItem.enclosure.url) {
				// Create media:group structure expected by the view components
				feedItem['media:group'] = {
					'media:content': [
						{
							$: {
								url: feedItem.enclosure.url
							}
						}
					]
				}
			}

			return feedItem
		})
	} catch (error) {
		console.error('Error fetching feed:', error)
		return []
	}
}

const useFeedApi = (): FeedItem[] => {
	const { data } = useSWR('feed', feedApiFetcher, {
		revalidateOnFocus: false,
		suspense: true,
	})

	return data ?? []
}

export default useFeedApi
